<template>
  <div class="dizhi">
    <div style="display:flex">
      <div style="padding-left:12px;">
          <el-button type="text"  @click="addxzdzFn(2)" size="mini"><i class="el-icon-location-outline  dizhiIcon" style="color:#67C23A"></i><span class="red">*</span>发货地址薄</el-button>
      </div>
      <div>
        <el-form-item    class="is-required" label="发货人:" prop="deliverPerson" v-if="goodform.deliverAddressId">
          <div style="width:80px">{{goodform.deliverPerson}}</div>
        </el-form-item>
        <el-form-item label="电话:" prop="deliverPhone" v-if="goodform.deliverAddressId">
          <div style="width:100px">{{goodform.deliverPhone}}</div>
        </el-form-item>
        <el-form-item   label="流向:" v-if="goodform.deliverAddressId">
          <div style="width:230px">{{goodform.startDirection}}</div>
        </el-form-item>
        <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1" v-if="goodform.deliverAddressId">
          <div style="min-width:150px">{{goodform.deliverAddress}}</div>
        </el-form-item>
      </div>
    </div>
    <div style="display:flex">
      <div  style="padding-left:12px;">
        <el-button type="text"  @click="addxzdzFn(1)"  size="mini"><i class="el-icon-location-outline dizhiIcon" style="color:#F56C6C"></i><span class="red">*</span>收货地址薄</el-button>
      </div>
      <span v-if="goodform.shFlag">
        <el-form-item class="is-required" label="收货人:" prop="receivingPerson" v-if="goodform.receivingAddressId">
          <div style="width:80px">{{goodform.receivingPerson}}</div>
        </el-form-item>
        <el-form-item label="电话:" prop="receivingPhone" v-if="goodform.receivingAddressId">
          <div style="width:100px">{{goodform.receivingPhone}}</div>
        </el-form-item>
        <el-form-item label="流向:" prop="receivingCompany" v-if="goodform.receivingAddressId">
          <div style="width:230px">{{goodform.endDirection}}</div>
        </el-form-item>
        <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1" v-if="goodform.receivingAddressId">
          <div style="min-width:150px">{{goodform.receivingAddress}}</div>
        </el-form-item>
      </span>
       <el-form-item label="" prop="receivingPhone" v-else style="padding-left:12px;">
        <div style="width:300px">{{goodform.xiedian}}<span class="red">(没有匹配到地址)</span></div>
      </el-form-item>

    </div>
    <el-dialog  title="选择地址" :close-on-click-modal="false" :close-on-press-escape="false"  @close="dialogVisible = false"
     :visible.sync="dialogVisible" width="1300px" center append-to-body>
      <div>
        <!--  :searchStr="searchStr" -->
        <publicAddress v-if="dialogVisible" :iszujian="1" @handleCurrentChange="handleCurrentChange"></publicAddress>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import publicAddress from '@/views/newTMS/publicFiles/publicAddress.vue'
import { getLocalAddress, sAddressList, getPrice, findKilometres } from '@/api/newTMS'
import { accSub } from '@/utils/util'
export default {
  name: 'addDizhi',
  components: {
    publicAddress
  },
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isPeizai: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      dialogVisible: false,
      addressType: 1
      // searchStr: this.goodform.xiedian
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (!this.goodform.deliverAddressId) {
      getLocalAddress().then(res => {
      // 收货
        this.$set(this.goodform, 'deliverCompany', res.company)
        this.$set(this.goodform, 'deliverPerson', res.person)
        this.$set(this.goodform, 'deliverPhone', res.phone)
        this.$set(this.goodform, 'deliverAddress', res.address)
        this.$set(this.goodform, 'deliverTaxpayerNumber', res.taxpayerNumber)
        this.$set(this.goodform, 'startDirection', res.name)
        this.goodform.deliverProvinceCode = res.provinceCode
        this.goodform.deliverCityCode = res.cityCode
        this.goodform.deliverAreaCode = res.areaCode
        this.goodform.deliverProvinceName = res.provinceName
        this.goodform.deliverCityName = res.cityName
        this.goodform.deliverAreaName = res.areaName
        this.goodform.deliverAddressId = res.id
        this.goodform.deliverLongitude = res.longitude
        this.goodform.deliverLatitude = res.latitude
        this.getPriceFn(this.goodform.xiedian)
        this.getGLS()
        if (this.isPeizai == 1) {
          this.$emit('getLiuxiang', { startDirection: res.name, type: '发货' })
        }
      })
    }
    if (!this.goodform.receivingAddressId) {
      sAddressList({ address: this.goodform.xiedian, pageNo: 1, pageSize: 50 }).then(res => {
        if (res.list.length > 0) {
          let row = res.list[0]
          // 收货
          this.$set(this.goodform, 'receivingCompany', row.company)
          this.$set(this.goodform, 'receivingPerson', row.person)
          this.$set(this.goodform, 'receivingPhone', row.phone)
          this.$set(this.goodform, 'receivingAddress', row.address)
          this.$set(this.goodform, 'receivingTaxpayerNumber', row.taxpayerNumber)
          this.$set(this.goodform, 'endDirection', row.name)
          this.goodform.receivingProvinceCode = row.provinceCode
          this.goodform.receivingCityCode = row.cityCode
          this.goodform.receivingAreaCode = row.areaCode
          this.goodform.receivingProvinceName = row.provinceName
          this.goodform.receivingCityName = row.cityName
          this.goodform.receivingAreaName = row.areaName
          this.goodform.receivingAddressId = row.id
          this.goodform.receivingLongitude = row.longitude
          this.goodform.receivingLatitude = row.latitude
          this.goodform.shFlag = true
          this.$set(this.goodform, 'shFlag', true)
          if (this.isPeizai == 1) {
            this.$emit('getLiuxiang', { endDirection: row.name, type: '收货' })
          }
          this.getGLS()
        } else {
          this.$set(this.goodform, 'shFlag', false)// 没有匹配到唯一地址
        }
      })
    } else {
      this.$set(this.goodform, 'shFlag', true)
    }

    if (!this.goodform.arriveDepartFlag) {
      this.$set(this.goodform, 'arriveDepartFlag', '否')
    }
  },
  methods: {
    async  getPriceFn (str) {
      let diyiduan = await getPrice({
        productType: (this.goodform.productTypeName == '中厚板' || this.goodform.productTypeName == '剪切板') ? 3 : this.goodform.productTypeName == '冷卷' ? 1 : 2, // 1. 冷卷 ，2 热卷，3. 中厚板
        keyWords: this.goodform.startDirection.replace(/-/g, '') + this.goodform.deliverAddress
      })
      let quancheng = await getPrice({
        productType: (this.goodform.productTypeName == '中厚板' || this.goodform.productTypeName == '剪切板') ? 3 : this.goodform.productTypeName == '冷卷' ? 1 : 2, // 1. 冷卷 ，2 热卷，3. 中厚板
        keyWords: str
      })
      if (quancheng && diyiduan) {
        this.$set(this.goodform, 'incomeUnitPrice', accSub(quancheng, diyiduan) < 0 ? 0 : accSub(quancheng, diyiduan))
      }
    },
    // 选择地址
    addxzdzFn (flag) {
      this.addressType = flag
      this.dialogVisible = true
    },
    handleCurrentChange (row) {
      if (!this.rule.xingming.test(row.person)) {
        this.$alert('联系人长度只支持2-20 个字符，必须为汉字。请修改后重新选择！', '系统提示')
        return
      }
      if (this.addressType == 1) {
        if (row.id == this.goodform.deliverAddressId) {
          this.$alert('收发货地址不能一样', '系统提示')
          return
        }
        // 收货
        this.$set(this.goodform, 'receivingCompany', row.company)
        this.$set(this.goodform, 'receivingPerson', row.person)
        this.$set(this.goodform, 'receivingPhone', row.phone)
        this.$set(this.goodform, 'receivingAddress', row.address)
        this.$set(this.goodform, 'receivingTaxpayerNumber', row.taxpayerNumber)
        this.$set(this.goodform, 'endDirection', row.name)
        this.goodform.receivingProvinceCode = row.provinceCode
        this.goodform.receivingCityCode = row.cityCode
        this.goodform.receivingAreaCode = row.areaCode
        this.goodform.receivingProvinceName = row.provinceName
        this.goodform.receivingCityName = row.cityName
        this.goodform.receivingAreaName = row.areaName
        this.goodform.receivingAddressId = row.id
        this.goodform.receivingLongitude = row.longitude
        this.goodform.receivingLatitude = row.latitude

        this.goodform.shFlag = true
        this.getPriceFn(row.name.replace(/-/g, '') + row.address)

        if (this.isPeizai == 1) {
          this.$emit('getLiuxiang', { endDirection: row.name, type: '收货' })
        }
      } else {
        if (row.id == this.goodform.receivingAddressId) {
          this.$alert('收发货地址不能一样', '系统提示')
          return
        }
        // 发货
        this.$set(this.goodform, 'deliverCompany', row.company)
        this.$set(this.goodform, 'deliverPerson', row.person)
        this.$set(this.goodform, 'deliverPhone', row.phone)
        this.$set(this.goodform, 'deliverAddress', row.address)
        this.$set(this.goodform, 'deliverTaxpayerNumber', row.taxpayerNumber)
        this.$set(this.goodform, 'startDirection', row.name)
        this.goodform.deliverProvinceCode = row.provinceCode
        this.goodform.deliverCityCode = row.cityCode
        this.goodform.deliverAreaCode = row.areaCode
        this.goodform.deliverProvinceName = row.provinceName
        this.goodform.deliverCityName = row.cityName
        this.goodform.deliverAreaName = row.areaName
        this.goodform.deliverAddressId = row.id
        this.goodform.deliverLongitude = row.longitude
        this.goodform.deliverLatitude = row.latitude
        if (this.isPeizai == 1) {
          this.$emit('getLiuxiang', { startDirection: row.name, type: '发货' })
        }
      }
      this.getGLS()
      this.dialogVisible = false
    },
    getGLS () {
      if (this.goodform.deliverLongitude && this.goodform.receivingLongitude) {
        findKilometres({
          deliverLongitude: this.goodform.deliverLongitude,
          deliverLatitude: this.goodform.deliverLatitude,
          receivingLongitude: this.goodform.receivingLongitude,
          receivingLatitude: this.goodform.receivingLatitude,
          arriveDepartFlag: this.goodform.arriveDepartFlag
        }).then(res => {
          this.$set(this.goodform, 'kilometres', res)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.$set(this.goodform, 'kilometres', '0')
      }
    }

  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
.dizhiIcon{
  font-size: 18px;
  margin-right: 4px;
}
.dizhi{
  /deep/.el-form-item--mini.el-form-item{
    margin-bottom:0!important;
  }
}
</style>
